module.exports = __webpack_public_path__ + "img/xj2.536bc1fe.png";